function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M141.277 150.1C141.752 148.765 143.078 147.977 144.428 148.129C144.991 148.192 145.553 148.242 146.118 148.209C160.214 147.38 177.673 155.45 196.259 166.503C179.245 152.736 163.673 140.558 145.358 153.073C144.05 153.967 142.196 153.651 141.435 152.261C141.13 151.703 141.019 151.034 141.202 150.344C141.223 150.262 141.248 150.181 141.277 150.1L141.277 150.1Z",
  fill: "#5E8DCD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M235.291 117.079C236.452 117.819 236.931 119.228 236.543 120.484L236.5 120.626C236.111 121.886 235.266 122.946 234.146 123.643C218.118 133.621 236.675 146.391 207.012 167.002C221.376 151.632 233.191 116.036 234.986 116.908C235.09 116.959 235.191 117.015 235.291 117.079Z",
  fill: "#5E8DCD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M259.857 195.105C259.26 196.347 257.918 196.989 256.625 196.753L256.479 196.726C255.181 196.491 254.029 195.777 253.204 194.748C241.394 180.018 230.917 199.959 206.93 172.952H206.93C223.897 185.391 260.643 192.897 259.99 194.783C259.953 194.891 259.908 194.999 259.857 195.105L259.857 195.105Z",
  fill: "#5E8DCD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M238.272 194.185C237.657 194.526 236.665 194.478 235.864 194.108L235.774 194.066C234.97 193.695 234.347 193.174 233.996 192.604C228.962 184.448 218.51 189.74 207.758 174.28C216.572 182.686 239.185 193.517 238.417 194.091C238.373 194.124 238.325 194.155 238.272 194.185V194.185Z",
  fill: "#5E8DCD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M243.122 161.654C242.97 162.341 242.277 163.052 241.468 163.406L241.377 163.446C240.566 163.802 239.764 163.922 239.104 163.808C229.661 162.171 226.695 173.505 207.992 171.307C220.129 170.28 243.228 160.528 243.148 161.483C243.144 161.538 243.135 161.595 243.122 161.654Z",
  fill: "#5E8DCD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M148.613 204.256C147.935 203.056 148.174 201.588 149.106 200.661L149.211 200.556C150.146 199.625 151.389 199.087 152.705 198.998C171.542 197.715 161.154 177.726 197.023 173.458C177.123 180.283 149.976 206.162 148.801 204.549C148.734 204.456 148.671 204.358 148.613 204.256V204.256Z",
  fill: "#5E8DCD"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M224.365 204.04C223.668 204.505 222.774 204.412 222.179 203.871L222.112 203.81C221.515 203.267 221.142 202.517 221.037 201.706C219.533 190.099 207.888 197.282 203.924 175.247C208.81 187.304 225.461 203.124 224.535 203.912C224.481 203.958 224.425 204 224.365 204.04L224.365 204.04Z",
  fill: "#5E8DCD"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M203.269 223.132C202.201 223.141 201.303 222.424 201.034 221.439L201.003 221.328C200.732 220.34 200.844 219.29 201.286 218.359C207.609 205.044 190.172 204.572 200.981 178.528C197.988 194.661 205.074 222.923 203.538 223.115C203.45 223.126 203.36 223.132 203.269 223.132V223.132Z",
  fill: "#0BAFFC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M164.638 204.936C163.95 204.12 163.93 202.97 164.516 202.135L164.582 202.04C165.17 201.202 166.051 200.618 167.049 200.364C181.336 196.739 170.576 183.01 197.528 174.72C183.196 182.707 165.951 206.193 164.824 205.132C164.759 205.071 164.697 205.006 164.638 204.936V204.936Z",
  fill: "#0BAFFC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M173.305 193.017C172.871 192.61 172.859 191.999 173.232 191.53L173.274 191.477C173.647 191.006 174.206 190.659 174.839 190.483C183.898 187.962 177.094 181.096 194.186 175.568C185.093 180.413 174.136 193.632 173.423 193.114C173.382 193.084 173.343 193.051 173.305 193.017Z",
  fill: "#0BAFFC"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M185.975 201.703C185.425 201.476 185.199 200.907 185.383 200.337L185.404 200.273C185.588 199.701 185.989 199.179 186.52 198.792C194.116 193.249 185.333 189.211 199.392 178.03C192.581 185.761 186.969 201.987 186.119 201.753C186.07 201.739 186.022 201.723 185.975 201.703Z",
  fill: "#5E8DCD"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M148.911 163.191L150.293 167.444H154.764L151.147 170.072L152.528 174.324L148.911 171.696L145.294 174.324L146.676 170.072L143.059 167.444H147.53L148.911 163.191Z",
  fill: "#0BAFFC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M210.524 112.228L211.906 116.48H216.377L212.76 119.108L214.142 123.36L210.524 120.732L206.907 123.36L208.289 119.108L204.672 116.48H209.143L210.524 112.228Z",
  fill: "#5E8DCD"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M243.231 157.867L244.613 162.119H249.084L245.467 164.747L246.849 168.999L243.231 166.372L239.614 168.999L240.996 164.747L237.379 162.119H241.85L243.231 157.867Z",
  fill: "#0BAFFC"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M177.056 204.267L178.437 208.519H182.908L179.291 211.147L180.673 215.399L177.056 212.771L173.439 215.399L174.82 211.147L171.203 208.519H175.674L177.056 204.267Z",
  fill: "#0BAFFC"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M202.157 157.867L203.539 162.119H208.01L204.393 164.747L205.774 168.999L202.157 166.372L198.54 168.999L199.922 164.747L196.305 162.119H200.776L202.157 157.867Z",
  fill: "#0BAFFC"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M236.675 112.228L238.056 116.48H242.527L238.91 119.108L240.292 123.36L236.675 120.732L233.058 123.36L234.439 119.108L230.822 116.48H235.293L236.675 112.228Z",
  fill: "#5E8DCD"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M146.567 196.267L148.319 200.38L152.773 199.985L149.402 202.922L151.154 207.036L147.319 204.738L143.948 207.675L144.949 203.317L141.113 201.019L145.567 200.624L146.567 196.267Z",
  fill: "#5E8DCD"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M184.815 117.706C185.621 117.309 186.527 117.577 187.041 118.296L187.098 118.377C187.614 119.099 187.859 120.012 187.816 120.946C187.201 134.313 200.57 128.338 200.548 153.914C197.754 139.423 183.511 118.539 184.616 117.819C184.679 117.778 184.746 117.74 184.815 117.706V117.706Z",
  fill: "#0BAFFC"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M173.155 137.519C173.513 137.072 174.099 137.011 174.579 137.326L174.633 137.362C175.114 137.677 175.49 138.179 175.707 138.765C178.816 147.157 184.899 140.132 191.507 155.9C186.162 147.668 172.627 138.358 173.071 137.638C173.097 137.597 173.125 137.557 173.155 137.519L173.155 137.519Z",
  fill: "#5E8DCD"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M162.866 161.91C162.915 161.34 163.368 160.963 163.941 160.958L164.006 160.958C164.582 160.953 165.173 161.161 165.68 161.527C172.929 166.774 174.08 157.552 188.339 166.985C179.319 163.114 162.893 162.901 162.862 162.056C162.86 162.007 162.861 161.958 162.866 161.91V161.91Z",
  fill: "#5E8DCD"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M0.2517 58.2077C0.982475 56.1558 3.0204 54.9446 5.09532 55.1772C5.96004 55.2742 6.824 55.3512 7.69263 55.3001C29.3574 54.026 56.191 66.4307 84.7565 83.4183C58.6065 62.2589 34.6731 43.541 6.52408 62.7766C4.51344 64.1505 1.66475 63.6653 0.495172 61.5293C0.0253027 60.6711 -0.144407 59.6427 0.135797 58.582C0.168857 58.4569 0.207453 58.332 0.25171 58.2077H0.2517V58.2077V58.2077Z",
  fill: "#5E8DCD"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M144.745 7.45494C146.53 8.59344 147.265 10.7586 146.67 12.6888L146.603 12.9066C146.006 14.8443 144.707 16.4722 142.986 17.5437C118.351 32.8797 146.873 52.506 101.281 84.1855V84.1855C123.359 60.5613 141.518 5.85236 144.277 7.19315C144.436 7.27038 144.592 7.35759 144.744 7.45495H144.745V7.45494Z",
  fill: "#5E8DCD"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M182.504 127.378C181.585 129.287 179.522 130.273 177.535 129.911L177.311 129.871C175.316 129.508 173.546 128.411 172.277 126.83C154.126 104.19 138.024 134.839 101.156 93.3306H101.156C127.234 112.448 183.712 123.984 182.708 126.883C182.65 127.05 182.582 127.215 182.503 127.378V127.378H182.504V127.378Z",
  fill: "#5E8DCD"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M149.327 125.964C148.381 126.489 146.857 126.415 145.626 125.846L145.487 125.782C144.251 125.211 143.295 124.41 142.754 123.534C135.017 110.999 118.953 119.134 102.428 95.3721H102.428C115.975 108.292 150.73 124.938 149.55 125.82C149.482 125.871 149.407 125.919 149.327 125.964V125.964Z",
  fill: "#5E8DCD"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M156.782 75.9655C156.548 77.0212 155.482 78.114 154.241 78.6584L154.1 78.7198C152.854 79.2667 151.62 79.4519 150.606 79.2761C136.092 76.7599 131.534 94.1798 102.789 90.8022H102.789C121.443 89.2232 156.945 74.2346 156.822 75.7032C156.815 75.7878 156.802 75.8753 156.782 75.9655H156.782Z",
  fill: "#5E8DCD"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M11.526 141.442C10.484 139.598 10.852 137.342 12.2839 135.917L12.4455 135.756C13.8821 134.326 15.7936 133.498 17.8163 133.361C46.7672 131.389 30.8023 100.668 85.9307 94.1074V94.1074C55.3451 104.598 13.622 144.372 11.816 141.893C11.712 141.75 11.6151 141.6 11.526 141.442V141.442V141.442Z",
  fill: "#5E8DCD"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M127.955 141.111C126.884 141.826 125.509 141.683 124.595 140.851L124.492 140.757C123.574 139.922 123.001 138.77 122.84 137.524C120.528 119.683 102.63 130.724 96.5371 96.8574H96.5371C104.047 115.388 129.639 139.703 128.215 140.915C128.133 140.984 128.046 141.05 127.955 141.111H127.955Z",
  fill: "#5E8DCD"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M95.5304 170.455C93.8901 170.468 92.5093 169.366 92.0954 167.852L92.0487 167.681C91.6326 166.163 91.8044 164.548 92.4833 163.119C102.201 142.654 75.4012 141.928 92.0147 101.9H92.0147C87.4151 126.695 98.3053 170.133 95.945 170.427C95.809 170.444 95.6707 170.454 95.5304 170.455H95.5304Z",
  fill: "#0BAFFC"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1544 142.488C35.0975 141.233 35.0659 139.466 35.9673 138.182L36.069 138.037C36.9731 136.748 38.3259 135.85 39.8601 135.461C61.8188 129.89 45.2816 108.788 86.7051 96.0474V96.0474C64.6768 108.322 38.172 144.419 36.4399 142.789C36.3401 142.695 36.2448 142.595 36.1544 142.488H36.1544Z",
  fill: "#0BAFFC"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M49.4786 124.168C48.8102 123.543 48.7922 122.604 49.365 121.883L49.4296 121.802C50.0041 121.078 50.8626 120.544 51.8354 120.273C65.7593 116.4 55.3022 105.846 81.5712 97.3506C67.5954 104.797 50.7552 125.113 49.6593 124.317C49.5961 124.271 49.5358 124.221 49.4786 124.168V124.168Z",
  fill: "#0BAFFC"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9515 137.519C68.1063 137.169 67.7593 136.296 68.0421 135.419L68.074 135.321C68.3575 134.441 68.9736 133.639 69.7893 133.044C81.4638 124.524 67.9647 118.319 89.5727 101.134C79.1052 113.016 70.4789 137.955 69.1729 137.595C69.0977 137.574 69.0238 137.549 68.9515 137.519V137.519Z",
  fill: "#5E8DCD"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9834 78.3286L14.1069 84.864H20.9786L15.4193 88.9031L17.5428 95.4384L11.9834 91.3993L6.42412 95.4384L8.54759 88.9031L2.98828 84.864H9.85997L11.9834 78.3286Z",
  fill: "#0BAFFC"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M106.679 0L108.802 6.53537H115.674L110.115 10.5744L112.238 17.1098L106.679 13.0707L101.119 17.1098L103.243 10.5744L97.6836 6.53537H104.555L106.679 0Z",
  fill: "#5E8DCD"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M156.95 70.1445L159.074 76.6799H165.945L160.386 80.719L162.51 87.2543L156.95 83.2153L151.391 87.2543L153.514 80.719L147.955 76.6799H154.827L156.95 70.1445Z",
  fill: "#0BAFFC"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M55.2413 141.459L57.3647 147.994H64.2364L58.6771 152.033L60.8006 158.569L55.2413 154.53L49.6819 158.569L51.8054 152.033L46.2461 147.994H53.1178L55.2413 141.459Z",
  fill: "#0BAFFC"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M93.8194 70.1445L95.9429 76.6799H102.815L97.2552 80.719L99.3787 87.2543L93.8194 83.2153L88.2601 87.2543L90.3835 80.719L84.8242 76.6799H91.6959L93.8194 70.1445Z",
  fill: "#0BAFFC"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M146.872 0L148.996 6.53537H155.867L150.308 10.5744L152.431 17.1098L146.872 13.0707L141.313 17.1098L143.436 10.5744L137.877 6.53537H144.749L146.872 0Z",
  fill: "#5E8DCD"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M8.38223 129.163L11.0751 135.485L17.9199 134.878L12.7394 139.392L15.4323 145.714L9.53767 142.183L4.35716 146.697L5.8946 140L0 136.468L6.84479 135.861L8.38223 129.163Z",
  fill: "#5E8DCD"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1669 8.41896C68.4064 7.80873 69.7995 8.22037 70.5882 9.32603L70.6772 9.45077C71.4694 10.5601 71.8458 11.9635 71.7798 13.3989C70.8346 33.9429 91.3824 24.7596 91.3486 64.0687H91.3486C87.0542 41.7976 65.1639 9.69909 66.8612 8.59305C66.959 8.52934 67.0609 8.47115 67.1669 8.41896H67.1669Z",
  fill: "#0BAFFC"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M49.2474 38.8702C49.7968 38.1843 50.6984 38.0897 51.4347 38.5739L51.5178 38.6285C52.2571 39.1141 52.8352 39.8849 53.1691 40.7861C57.9475 53.6834 67.2972 42.8866 77.4533 67.1209C69.2375 54.4691 48.4356 40.16 49.118 39.054C49.1573 38.9903 49.2004 38.9289 49.2474 38.8702L49.2474 38.8702Z",
  fill: "#5E8DCD"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4325 76.3584C33.5078 75.4827 34.2046 74.9029 35.0858 74.8959L35.1852 74.8951C36.0697 74.8878 36.9788 75.2071 37.7573 75.7704C48.8998 83.834 50.6684 69.6614 72.5839 84.1584C58.7208 78.21 33.4748 77.8818 33.427 76.5831C33.4243 76.5083 33.426 76.4333 33.4325 76.3584H33.4325Z",
  fill: "#5E8DCD"
});

function SvgIcSparks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 224,
    viewBox: "0 0 260 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSparks);
export default __webpack_public_path__ + "static/media/ic_sparks.fbc00f736f6e9fec17bf6cf34bfcbbc6.svg";
export { ForwardRef as ReactComponent };